/**
 * API Endpoints
 *
 * Centralized endpoint definitions for correspondence service
 * Extracted from workflow-data.service.ts for better maintainability
 */

/**
 * Backend API endpoint definitions
 * These are the actual endpoints called via server actions
 */
export const BACKEND_ENDPOINTS = {
  correspondences: (matterId: number) => `/matters/${matterId}/correspondences`,

  bulkCorrespondences: (matterId: number) =>
    `/matters/${matterId}/correspondences/bulk`,

  sendCorrespondence: (matterId: number, id: number) =>
    `/matters/${matterId}/correspondences/${id}/send`,

  previewLetter: (matterId: number, id: number) =>
    `/matters/${matterId}/correspondences/${id}/preview-letter`,

  institutionForms: (matterId: number, institutionId: number) =>
    `/matters/${matterId}/institutions/${institutionId}/forms`,

  printPackage: (matterId: number, correspondenceId: number) =>
    `/matters/${matterId}/correspondences/${correspondenceId}/print-package`
};
